module.exports = __webpack_public_path__ + "static/media/epc.f5b0c359.svg";